module.exports = __webpack_public_path__ + "files/598f045c3551813bf18a517ec7a39f52.png";